enum SellerType {
    /** 淘宝 */
    TAOBAO = "TAOBAO",
    /** 天猫 */
    TMALL = "TMALL",
    /** 淘特 */
    TAOTE = "TAOTE",
    /** 京东自营厂送 */
    JD_DROPSHIP = "JD_DROPSHIP",
    /** 京东第三方 */
    JD_SOP = "JD_SOP",
    /** 京东快递外单 */
    JD_EXPRESS_AUTH = "JD_EXPRESS_AUTH",
    /** 京东分销 */
    JD_PURCHASE = "JD_PURCHASE",
}

export default SellerType;
